export default "__VITE_PUBLIC_ASSET__45bf1cf8__"